/**
 * Narwhalia backend
 * Swagger API docs for Narwhalia Backend application
 *
 * OpenAPI spec version: 0.9
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/** The price of the entity */
export class PriceDto {
	constructor(
		/**
		 * The actual price when the response created. The client must store the actual time and start the calculation based on that.
		 * This price is valid until the end of the actual interval.
		 * The end of the interval can be calculates as: [act time] + (remaningMins mod <priceChangeInterval>)
		 */
		public act: number,
		/** Remaining time in minutes until the complete sale ends (when endPrice must be reached)  0 if expired -1 if should not be moved */
		public minsToEnd?: number,
		/** The final price @ the end of the sale null if minsToEnd is null */
		public end?: number
		) {
	}
}